import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { getNodeMeta, Inspector } from '@react-email/editor/ui';
import type { ReactNode } from 'react';

import { LIQUID_VARIABLE_NODE } from '../../extensions/liquidVariableNodes';

export const InspectorBreadcrumb = () => {
	const tMipManage = useTranslationMipManage();
	// getNodeMeta only knows the library's own node types.
	const nodeLabel = (nodeType: string) =>
		nodeType === LIQUID_VARIABLE_NODE
			? tMipManage('email_templates.editor.inspector.variable', {
					defaultValue: 'Variable',
				})
			: getNodeMeta(nodeType).label;

	// Called, not mounted as JSX: the library types its return as including
	// `bigint` and `Promise`, which this React version's ReactNode rejects.
	const rendered = Inspector.Breadcrumb({
		children: (segments) => (
			<nav data-re-inspector-breadcrumb="">
				<ol data-re-inspector-breadcrumb-list="">
					{segments.map((segment, index) => {
						const isLast = index === segments.length - 1;
						const name =
							index === 0
								? tMipManage('email_templates.editor.inspector.global', {
										defaultValue: 'Global',
									})
								: nodeLabel(segment.node.nodeType);
						const label = isLast
							? tMipManage('email_templates.editor.inspector.properties_of', {
									defaultValue: '{{name}} properties',
									name,
								})
							: name;

						return (
							<li
								key={segment.node.nodeType + String(index)}
								data-re-inspector-breadcrumb-item=""
							>
								{index > 0 && (
									<span data-re-inspector-breadcrumb-separator="">/</span>
								)}
								<button
									type="button"
									data-re-inspector-breadcrumb-button=""
									data-clickable={isLast ? undefined : ''}
									onClick={isLast ? undefined : segment.focus}
								>
									{label}
								</button>
							</li>
						);
					})}
				</ol>
			</nav>
		),
	});

	if (typeof rendered === 'bigint' || rendered instanceof Promise) {
		return null;
	}

	const content: ReactNode = rendered;
	return <>{content}</>;
};
